import posthog from "posthog-js";

export type PostHogEvent =
  | "cta_clicked"
  | "signup_email_submitted"
  | "signup_completed"
  | "pricing_page_viewed"
  | "checkout_initiated"
  | "checkout_completed"
  | "dashboard_loaded"
  | "onboarding_step_completed"
  // Onboarding / ZAI activation funnel (Bloco A/E)
  | "onboarding_started"
  | "zai_started"
  | "zai_method_selected"
  | "upload_started"
  | "upload_success"
  | "upload_failed"
  | "extraction_started"
  | "extraction_success"
  | "extraction_failed"
  | "extraction_zero_items"
  | "products_typed"
  | "whatsapp_added"
  | "extra_info_added"
  | "logo_added"
  | "cover_added"
  | "first_item_created"
  | "preview_viewed"
  | "test_order_clicked"
  | "activation_screen_viewed"
  | "menu_created"
  | "menu_viewed"
  | "item_added_to_cart"
  | "order_placed"
  | "free_plan_limit_hit"
  | "ai_waiter_opened"
  | "ai_waiter_message_sent"
  | "ai_waiter_nudge_shown"
  | "ai_waiter_quick_add"
  | "ai_waiter_upsell_triggered"
  | "ai_waiter_finalize_clicked"
  | "activation_step_checked"
  | "activation_template_copied"
  | "activation_whatsapp_share_opened"
  | "activation_poster_opened"
  | "activation_banner_dismissed"
  | "growth_action"
  | "setup_form_viewed"
  | "setup_form_submitted"
  | "balcao_order_placed"
  | "trial_converted"
  | "plan_upgraded"
  | "plan_downgraded"
  | "subscription_cancelled";

export function isTestPreview(): boolean {
  return typeof window !== "undefined"
    && new URLSearchParams(window.location.search).get("is_test") === "true";
}

export function phCapture(event: PostHogEvent, properties?: Record<string, unknown>) {
  if (!isTestPreview() && posthog.__loaded) {
    posthog.capture(event, properties);
  }
}
